import { LinkButton } from "@hfc/shared/components/Button"

const Lobby = () => {
	return (
		<div
			id="lobby"
			className="flex items-center justify-center min-h-screen py-10 text-yellow-50"
		>
			<div className="container text-center max-w-7xl">
				<div className="mb-10">
					<h1 className="text-4xl">Welcome to the Howdy Games</h1>
				</div>

				<div>
					<LinkButton
						href="/metaverse"
						variant="secondary"
						className="w-full px-5 py-5 text-xl font-black"
					>
						Enter Metaverse
					</LinkButton>
				</div>
			</div>
		</div>
	)
}

export default Lobby
